import { Widget } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/ChatWidget/Widget";
import { dropMessages } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/ChatWidget/api";
import { useIntegrationConversation } from "../hooks/useIntegrationConversation";
import "../../../../styles/css/chat_bpe.css";
import { useEffect } from "react";
import { createMessageToolsFactory } from "./MessageToolsFactory";
import { Integration } from "../../../../models/Entities";

export function IntegrationChatWidget({
  integration_id,
  higherPlacement = false,
}: {
  integration_id: string;
  higherPlacement?: boolean;
}) {
  // Create a simple Integration object with just the id
  const integration: Integration = { id: integration_id } as Integration;

  const { send } = useIntegrationConversation(integration);

  // hook where we drop current messages when integration_id changes
  useEffect(() => {
    // 1. Drop messages immediately if integration_id changes
    dropMessages();

    // 2. Before the browser unloads, drop messages too
    const handleBeforeUnload = () => {
      dropMessages();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 3. Cleanup: on component un‐mount or integration_id change,
    //    remove listener and drop messages one last time
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      dropMessages();
    };
  }, [integration_id]);

  const handleNewUserMessage = async (text: string): Promise<string | void> => {
    return send(text);
  };

  // Create message tools factory with integration context and sessionId for feedback tracking
  const messageToolsFactory = createMessageToolsFactory();

  return (
    <Widget
      handleNewUserMessage={handleNewUserMessage}
      title="ChatBPE"
      subtitle="Ask questions about this integration"
      senderPlaceHolder="Ask about this integration... REMINDER: DO NOT INPUT CUSTOMER DATA OR SENSITIVE INFORMATION"
      createMessageTools={messageToolsFactory}
      higherPlacement={higherPlacement}
    />
  );
}
